import { h1, p, strong, code, wrapHTML } from './htmlUtils';
import { parseMarkdownFull } from './htmlUtils';

/**
 * Filter out the RAW TERMS section from the markdown.
 * That section is for internal use by marketing_strategist_agent, not for the user.
 */
function filterInternalSections(markdown: string): string {
  return markdown.replace(/(-{3}\s*)?## RAW TERMS \(for content optimization\)[\s\S]*$/, '').trim();
}

/**
 * Format SEO Content Analysis data as HTML (matches SEOContentRenderer.tsx)
 */
export const formatSEOContentHTML = (data: any): string => {
  if (!data || (!data.response_text && !data.query && !data.query_url)) {
    return wrapHTML(p('No SEO content analysis available'));
  }

  const sections: string[] = [];

  // Header
  sections.push(h1('SEO Content Analysis'));

  // Scored state — content evaluation result
  if (data.status === 'scored' && data.content_score != null) {
    sections.push(h1('Content Score'));
    sections.push(p(`${strong('Your Score:')} ${data.content_score}`));
    if (data.target_score != null) {
      sections.push(p(`${strong('Target (competitor median):')} ${data.target_score}`));
      sections.push(
        p(
          data.passed
            ? `${strong('Result:')} Above target — your content is competitive.`
            : `${strong('Result:')} Below target — improvements recommended.`,
        ),
      );
    }
    if (data.passed === false && data.response_text) {
      const optionsText = data.response_text
        .replace(/^# Content Score:.*\n?/, '')
        .replace(/\*\*Target.*\n?/, '')
        .replace(/\*\*Result.*\n?/, '')
        .trim();
      if (optionsText) {
        sections.push(parseMarkdownFull(optionsText));
      }
    }
    return wrapHTML(sections.join(''));
  }

  // Ready state — full analysis
  if (data.status === 'ready' && data.response_text) {
    const cleanMarkdown = filterInternalSections(data.response_text);
    sections.push(parseMarkdownFull(cleanMarkdown));
    if (data.query) {
      sections.push(p(`${strong('Query ID:')} ${code(data.query)}`));
    }
    return wrapHTML(sections.join(''));
  }

  // Processing state
  if (data.status === 'waiting' || data.status === 'in progress') {
    sections.push(
      p(
        'Your SEO content analysis is being processed. This typically takes about 90 seconds. Please check back in a moment.',
      ),
    );
    if (data.query) {
      sections.push(p(`${strong('Query ID:')} ${code(data.query)}`));
    }
    return wrapHTML(sections.join(''));
  }

  // Created state — brief just submitted
  if (data.response_text) {
    sections.push(p(data.response_text));
  }

  if (data.query) {
    sections.push(p(`${strong('Query ID:')} ${code(data.query)}`));
  }

  return wrapHTML(sections.join(''));
};
